// @flow

import * as React      from 'react';
import * as Reactstrap from "reactstrap";
import styled          from 'styled-components';
import linkTargets     from './linkTargets';


// -----------------------------------------------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------------------------------------------

const InfoTable      = styled(Reactstrap.Row)``;
const InfoTypeCol    = styled(Reactstrap.Col).attrs({xs: 12, sm: 3, xl: 2})`
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
`;
const InfoDetailsCol = styled(Reactstrap.Col).attrs({xs: {size: 11, offset: 1}, sm: {size: 9, offset: 0}, xl: 10})``;

const CookieHeader  = styled('div').attrs({children: 'Cookies'})`
  font-weight: 900;
`;
const CookieTable   = styled(Reactstrap.Row)``;
const CookieName    = styled(Reactstrap.Col).attrs({xs: {size: 'auto'}})`
  width: 7rem;
  &:after {
    content: ':';
  }
`;
const CookieDetails = styled(Reactstrap.Col)``;


// -----------------------------------------------------------------------------------------------------------------
// Config
// -----------------------------------------------------------------------------------------------------------------

export type CookieTypeConfig = {
  title: string,
  required: boolean,
  info: React.Node,
}

export type CookieType =
  | 'websiteData'
  | 'provisioning'
  | 'userPreferences'
  | 'analytics';


const cookiesConfig: { [CookieType]: CookieTypeConfig } = {
  websiteData:     {
    title:    'Website Data - The core information',
    required: true,
    info:     <p>We store copies of information provided by the directory services to allow us to provide a service
      that's nice and fast for you, so that we don't need to download information again and again. This data only
      contains public information, and is only stored for a short while, and is cleared as soon as you close your web
      browser.</p>,
  },
  provisioning:    {
    title:    'Provisioning - Getting the website to you',
    required: true,
    info:     React.Children.toArray([
      <p>In order to provide the directory service to you in nice, quickly, and safely we also use a few, carefully
        selected third party vendors. In order for these vendors to provide their service they store cookies on </p>,
      <p>We use the following vendor services…</p>,
      <InfoTable>
        <InfoTypeCol>CloudFlare</InfoTypeCol>
        <InfoDetailsCol>
          <p>We use Cloudflare to enhance your experience by providing the website files from a server
            closer to you</p>
          <CookieHeader/>
          <CookieTable>
            <CookieName>__cfduid &amp;<br/>__cfruid</CookieName>
            <CookieDetails>To identify you as a trusted web user, and prevent traffic from less legitimate
              visitors.</CookieDetails>
          </CookieTable>
        </InfoDetailsCol>
      </InfoTable>,
    ]),
  },
  userPreferences: {
    title:    'Your Preferences - Make the site your own',
    required: false,
    info:     <p>In order to allow you to customise the service the way you want to we need to store information about
      your preferences. This ranges from simple preferences, such as remembering your preferred font size between page
      refreshes, to storing information that allows you to register for, and log in and out of your account, allowing
      you to persist your preferences between multiple devices.</p>,
  },
  analytics:       {
    title:    'Analytics - Help us to help you',
    required: false,
    info:     <div>
                <p>In order to help us help you, we need know how visitors use our site, so that we can improve how the
                  site works for you, the people using the site. In order to do this we
                  collect <strong>anonymous</strong> data about how visitors move around and interact with the
                  directory. Allowing us to set these cookies means that we can improve how the site works for you.</p>

                <InfoTable>
                  <InfoTypeCol>Google Analytics</InfoTypeCol>
                  <InfoDetailsCol>
                    <p>Google Analytics uses cookies to help us analyse how our users use our websites and services. You
                      can find out more about this service and how Google uses your data at <a
                        href="http://www.google.com/analytics"
                        target={linkTargets.reference}>http://www.google.com/analytics</a> and <a
                        href="http://www.google.com/policies/privacy/partners/"
                        target={linkTargets.reference}>http://www.google.com/policies/privacy/partners/</a>.
                    </p>

                    <CookieHeader/>
                    <p>Details of the Google Analytics cookies can be found on <a
                      href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
                      target={linkTargets.reference}>the Google Analytics website</a>.
                    </p>
                  </InfoDetailsCol>
                </InfoTable>
              </div>,
  },
};

// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default cookiesConfig;



// WEBPACK FOOTER //
// ./src/config/cookiesConfig.js